import { useQuery } from "@tanstack/react-query";

import { getFastenerBrands, type FastenerBrand } from "../api/filter";

export function useFastenerBrands() {
  return useQuery<FastenerBrand[]>({
    queryKey: ["filter-options", "fastener-brands"],
    queryFn: getFastenerBrands,
    staleTime: 5 * 60 * 1000,
  });
}
